import { baseAssets, darkModeBaseAssets, selectAssets, selectDarkModeAssets, ThemeAssets } from './theme/assets'
import { darkThemeColors, lightThemeColors, ThemeColors } from './theme/colors'
import { lyraSelectDarkThemeColors, lyraSelectLightThemeColors } from './theme/LyraSelectColors'
import { Theme } from './theme/theme'

export enum PRODUCT_TYPE {
  WFMH = 'WFMH',
  SELECT = 'SELECT',
}

export const DEFAULT_PRODUCT_TYPE = PRODUCT_TYPE.WFMH

export type ThemeMetadata = {
  colorTokens: ThemeColors
  assets: ThemeAssets
}

type productTypeMetadata = {
  theme: {
    [Theme.DARK]: ThemeMetadata
    [Theme.LIGHT]: ThemeMetadata
  }
}

type productTypeToMetadata = {
  [key in PRODUCT_TYPE]: productTypeMetadata
}

export const defaultProductTypesToMetadata: productTypeToMetadata = {
  [PRODUCT_TYPE.WFMH]: {
    theme: {
      [Theme.DARK]: {
        colorTokens: darkThemeColors,
        assets: darkModeBaseAssets,
      },
      [Theme.LIGHT]: {
        colorTokens: lightThemeColors,
        assets: baseAssets,
      },
    },
  },
  [PRODUCT_TYPE.SELECT]: {
    theme: {
      [Theme.DARK]: {
        colorTokens: lyraSelectDarkThemeColors,
        assets: selectDarkModeAssets,
      },
      [Theme.LIGHT]: {
        colorTokens: lyraSelectLightThemeColors,
        assets: selectAssets,
      },
    },
  },
}
